import { useState } from "react";
import { ResponsibleGamingTabs } from "./ResponsibleGamingTabs";
import { DepositLimit } from "./DepositLimit";
import { TakeABreak } from "./TakeABreak";
import { SelfExclusion } from "./SelfExclusion";

export function ResponsibleGaming() {
  const [activeTab, setActiveTab] = useState("deposit-limit");

  const onTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  let content = null;

  switch (activeTab) {
    case "deposit-limit":
      content = <DepositLimit />;
      break;
    case "take-a-break":
      content = <TakeABreak />;
      break;
    case "self-exclusion":
      content = <SelfExclusion />;
      break;
  }

  return (
    <div>
      <div>
        <ResponsibleGamingTabs
          activeTab={activeTab}
          onTabChange={onTabChange}
        />
      </div>

      <div className="py-4 mt-4">{content}</div>
    </div>
  );
}
